import styled, { RuleSet } from 'styled-components';
import { Typography } from '../../ui/Typography';
import { Breakpoints } from '../../../styled/constants';
import { FlexCenterAligned } from '../../../styled/common';

export const InfoViewsContainer = styled(FlexCenterAligned)<{
  $styles?: RuleSet<object>;
}>`
  position: absolute;
  right: 15px;
  top: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 14px;
  z-index: 3;

  @media (min-width: ${Breakpoints.tablet}px) {
    right: 30px;
    top: 15px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    position: static;
    path {
      fill: ${({ theme }) => theme.colors.text.primary};
    }
  }

  ${({ $styles }) => $styles}
`;

export const InfoViewsText = styled(Typography)`
  color: ${({ theme }) => theme.colors.background.primary};
  white-space: nowrap;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
